import React, { useState } from "react";
import { useNavigate } from "react-router-dom"
import { ArrowLeft, Check, UploadCloud } from "lucide-react"
import "../../_css/RoleplayManagement.css"



const subcategories = [
    {
        "id": "01",
        "name": "Sensitive Employee Conversations",
        "selected": "false"
    },
    {
        "id": "02",
        "name": 'Performance Improvement and Feedback',
        "selected": "true"
    }
    ,
    {
        "id": "01",
        "name": "Sensitive Employee Conversations",
        "selected": "false"
    },
    {
        "id": "02",
        "name": 'Performance Improvement and Feedback',
        "selected": "false"
    }
    ,
    {
        "id": "01",
        "name": "Sensitive Employee Conversations",
        "selected": "false"
    },
    {
        "id": "02",
        "name": 'Performance Improvement and Feedback',
        "selected": "false"
    }
    ,
    {
        "id": "01",
        "name": "Sensitive Employee Conversations",
        "selected": "false"
    },
    {
        "id": "02",
        "name": 'Performance Improvement and Feedback',
        "selected": "false"
    }


]
const AddCategories = () => {
    const navigate = useNavigate();
    const [selectedStyle, setSelectedStyle] = useState([]);
    const [hoveredStyle, setHoveredStyle] = useState(false)
    const [categoryTitle, setCategoryTitle] = useState("");
    const [categoryDescription, setCategoryDiscription] = useState('');


    const countWords = (text) => text.trim().split(/\s+/).filter(Boolean).length;
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: "24px"
        }}>
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "16px"
            }}>
                <button
                    onClick={() => navigate('/roleplayManagement')}
                    style={{
                        width: "42px",
                        height: "42px",
                        borderRadius: "50%",
                        background: "#FFFFFF",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        backdropFilter: "blur(10px)"

                    }}
                >
                    <ArrowLeft size={20} color="#171717" />
                </button>
                <h1
                    className='font-clash-display'
                    style={{
                        fontWeight: "600",
                        fontSize: "24px",
                        lineHeight: "32px",
                        color: "#374151",
                        // margin: 0
                    }}
                >
                    Add categories
                </h1>
            </div>

            {/* Main Content */}
            <div style={{
                display: "flex",
                background: '#FFFFFF',
                borderRadius: "16px",
                padding: "32px",
                flexDirection: "column",
                gap: '24px'
            }}>
                {/* Title */}
                <div style={{
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column"
                }}>
                    <h1 style={{
                        fontFamily: "ClashDisplay-Semibold",
                        fontSize: "24px",
                        lineHeight: "32px",
                        color: "#000000"
                    }}>
                        Category details
                    </h1>
                </div>
                {/* scenario title */}
                <div className=" font-plus-jakarta-sans " style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px"
                }}>
                    <div className="" style={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}>
                        <label className="" style={{
                            fontSize: "14px",
                            lineHeight: '20px',
                            fontWeight: 700,
                            fontFamily: "Plus Jakarta Sans",
                            color: "#6B7280"
                        }}>
                            Title
                        </label>

                    </div>
                    <textarea
                        // ref={textareaRef}
                        className="form-control custom-placeholder"
                        placeholder="HR"
                        value={categoryTitle}
                        onChange={(e) => setCategoryTitle(e.target.value)}
                        rows={1}
                        style={{
                            borderRadius: "16px",
                            padding: " 16px",
                            fontSize: "14px",
                            background: "#F9FAFB",
                            resize: "none",
                            border: "1px solid #E5E7EB",
                            boxShadow: "none",
                            color: "#111827",
                            outline: "none",
                            pointerEvents: "auto",
                            cursor: "text",
                            minHeight: "40px", // Minimum height
                            overflow: "hidden" // Hide scrollbar since we're auto-resizing
                        }}
                    />
                </div>
                {/* scenario description */}
                <div className=" font-plus-jakarta-sans " style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px"
                }}>
                    <div className="" style={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}>
                        <label className="" style={{
                            fontSize: "14px",
                            lineHeight: '20px',
                            fontWeight: 700,
                            fontFamily: "Plus Jakarta Sans",
                            color: "#6B7280"
                        }}>
                            Description
                        </label>
                    </div>
                    <textarea
                        // ref={textareaRef}
                        className="form-control custome-placeholder"
                        placeholder="You are an HR professional conducting a one-on-one meeting with an employee whose performance has been below expectations. The employee is unaware of the issue and does not recognize that their performance is lacking. Your task is to provide clear and constructive feedback, encourage reflection, and ensure they understand what is expected moving forward."
                        value={categoryDescription}
                        onChange={(e) => setCategoryDiscription(e.target.value)}
                        rows={3}
                        style={{
                            borderRadius: "16px",
                            padding: "7px 16px",
                            fontSize: "14px",
                            background: "#F9FAFB",
                            resize: "none",
                            border: "1px solid #E5E7EB",
                            boxShadow: "none",
                            // color: "#111827",
                            outline: "none",
                            pointerEvents: "auto",
                            cursor: "text",
                            minHeight: "40px", // Minimum height
                            overflow: "hidden" // Hide scrollbar since we're auto-resizing
                        }}
                    />
                </div>
                {/* subcategory */}
                <div style={{
                    display: "flex",
                    flexDirection: 'column',
                    gap: '16px'
                }}>
                    <div>
                        <label className="" style={{
                            fontSize: "14px",
                            lineHeight: '20px',
                            fontWeight: 700,
                            fontFamily: "Plus Jakarta Sans",
                            color: "#6B7280"
                        }}>
                            Sub Category
                        </label>
                    </div>
                    <div style={{
                        display: "flex",
                        // flexDirection: 'column'
                        flexWrap: "wrap",
                        gap: '8px'
                    }}>
                        {
                            subcategories.map(subcategory => (
                                <div key={subcategory.id} style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "4px 12px",
                                    // background: "#F9FAFB",
                                    borderRadius: "33px",
                                    gap: "6px",


                                }}>
                                    <input
                                        type="checkbox"
                                        id={`subcategory-${subcategory.id}`}
                                        // checked={subcategory.selected}
                                        // onChange={() => handleSubcategoryToggle(subcategory.id)}
                                        style={{
                                            width: "16px",
                                            height: "16px",
                                            // marginRight: "12px",
                                            border: " 1px solid #9CA3AF"
                                        }}
                                    />
                                    <label
                                        htmlFor={`subcategory-${subcategory.id}`}
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "24px",
                                            color: "#6B7280",
                                            // flex: 1,
                                            cursor: "pointer",
                                            fontFamily: 'Plus Jakarta Sans'
                                        }}
                                    >
                                        {subcategory.name}
                                    </label>
                                </div>
                            ))}
                    </div>
                </div>
                <span style={
                    {
                        fontFamily: "Plus Jakarat Sans",
                        fontSize: '14px',
                        lineHeight: "20px",
                        verticalAlign: 'middle',
                        textDecoration: 'underline ',
                        color: '#23B4C3',
                        fontWeight: 400,
                        cursor: "pointer"
                    }
                }>Add more subcategory</span>
                <button className="next-button" style={{
                    color: "#FFFFFF"
                }}
                >Save
                </button>
            </div>
        </div>
    )

}
export default AddCategories;
